module.exports = __webpack_public_path__ + "static/img/newanli-03.64ff023c.jpg";